import Select from '@components/v2/form/Select/Select';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import LangEnum from '../../../../lang/LangEnum';
import timezones from '../../../../utils/timezones';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { TimezoneSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const TimezoneSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: TimezoneSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  const timezoneItems = timezones.map((tz) => ({
    value: tz.value,
    label: `(${tz.gmt}) ${tz.locale}`,
  }));

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_TIMEZONE)}
      description={LangEnum.GENERAL_SETTINGS_TIMEZONE_DESCRIPTION}
    >
      <Select
        label={translate(LangEnum.GLOBAL_TIMEZONE)}
        name="timezone"
        value={generalSettings.timezone ?? ''}
        renderValue={(selected) =>
          timezoneItems.find((item) => item.value === selected)?.label ?? ''
        }
        onChange={(event) =>
          handleChangeAndBlur({ value: (event.target.value as string) || null, name: 'timezone' })
        }
      >
        {timezoneItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </SettingContainer>
  );
};

export default TimezoneSectionGeneralSettings;
